// 用户信息
export class UserInfoModel{
    id: number;
    name: string;
    email: string;
    expireTime: number | string;
    memberType: number;
    firstName: string;
    lastName: string;
    preferredName: string;
    fullName: string;
    school: string;
    job: string;
    qualifications: string;
    code: string | number;

    constructor(data?: any){
        if (data){
            const info = data.userInfo;

            this.id = data.userId;
            this.name = data.userName;
            this.email = info.userEmail;
            this.expireTime = data.expireTime;
            this.memberType = data.userRole;
            this.firstName = info.userFn;
            this.lastName = info.userLn;
            this.preferredName = info.userPn;
            this.fullName = `${info.prefix} ${info.userFn} ${info.userLn}`;
            this.school = info.userSchool;
            this.job = info.userJob;
            this.qualifications = info.userCodeType;
            this.code = info.userCode;
        }
    }
}


export class UserModel {


    createTime: string;
    prefix: string;
    updateTime: string;
    userAg: string;
    userCode: string;
    userFn: string;
    userInfoId: number;
    userJob:string;
    userLn: string;
    userPn: string;
    userRe: string;
    userRi: string;
    userRn: string;
    userSchool: string;




  constructor(options?: any) {
    if (options) {

      this.createTime = options.userInfo.createTime;
      this.prefix = options.userInfo.prefix;
      this.updateTime = options.userInfo.updateTime;
      this.userAg = options.userInfo.userAg;
      this.userCode = options.userInfo.userCode;
      this.userFn = options.userInfo.userFn;
      this.userInfoId = options.userInfo.userInfoId;
      this.userJob = options.userInfo.userJob;
      this.userLn = options.userInfo.userLn;
      this.userPn = options.userInfo.userPn;
      this.userRe = options.userInfo.userRe;
      this.userRi = options.userInfo.userRi;
      this.userRn = options.userInfo.userRn;
      this.userSchool = options.userInfo.userSchool;
    }
  }
}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/model/user.model.ts